<template>
	<div class="c-card-item" :class="{ 'c-card-item--border': border }" @click.stop="goToDetail(item)">
		<div class="c-date">
			<i class="iconfont iconiconhuiyishijian"></i>
			<span>{{ item.publishDate }}</span>
		</div>
		<div class="c-title">{{ item.title }}</div>
	</div>
</template>

<script>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
export default {
	props: {
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		border: {
			type: Boolean,
			default: true
		},
		isUsAnnouncement: {
			type: Boolean,
			default: false
		}
	},
	computed: {},
	methods: {
		goToDetail(item) {
			this.viewModule(this.isUsAnnouncement ? 'us_announcement' : 'announcement', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		return {
			viewModule
		};
	}
};
</script>

<style lang="less" scoped>
@import '../../../style/mixins';
.c-card-item {
	padding-bottom: 0.14rem;
	& + .c-card-item {
		margin-top: 0.14rem;
	}
	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	.c-date {
		padding: 0 0.06rem;
		display: inline-flex;
		align-items: center;
		height: 0.17rem;
		border-radius: 100px;
		color: var(--ir-theme-color);
		background: var(--ir-theme-color-opacity-1);

		.iconiconhuiyishijian {
			margin-right: 0.04rem;
			font-size: 0.12rem;
		}
		span {
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.15rem; /* 136.364% */
		}
	}
	.c-title {
		padding-top: 0.08rem;
		color: #333;
		font-size: 0.14rem;
		font-weight: 500;
		line-height: 140%; /* 21px */
		.text-overflow-multi-row(3);
	}
}
</style>
